import { LitElement, html, nothing } from 'lit';
import type { GoalListSectionRenderModel } from './shared';
import { defineZenComponent } from './register';

export class ZenGoalList extends LitElement {
  static properties = {
    sections: { attribute: false },
    moreLabel: { attribute: false },
  };

  declare sections: GoalListSectionRenderModel[];
  /** #2739: when set, a button under the list asks for the next page. */
  declare moreLabel: string;

  constructor() {
    super();
    this.sections = [];
    this.moreLabel = '';
  }

  private requestMore() {
    this.dispatchEvent(new CustomEvent('goal-list-load-more', { bubbles: true, composed: true }));
  }

  createRenderRoot() {
    return this;
  }

  renderSection(section: GoalListSectionRenderModel) {
    if (!section.label) {
      return html`
        <div class="goals-grid">
          ${section.goals.map((goal) => html`<zen-goal-card .goal=${goal}></zen-goal-card>`)}
        </div>
      `;
    }

    const labelClass = section.tone === 'overdue' ? 'today-section-label overdue' : 'today-section-label';
    const countClass = section.tone === 'overdue' ? 'today-section-count overdue' : 'today-section-count';
    const iconStyle = section.tone === 'warning' ? 'color:var(--warning-text)' : nothing;
    const labelStyle = section.tone === 'warning' ? 'color:var(--warning-text)' : nothing;

    return html`
      <div class="today-section-header">
        <span class="mi mi-xs" style=${iconStyle}>${section.icon}</span>
        <span class=${labelClass} style=${labelStyle}>${section.label}</span>
        <span class=${countClass}>${section.count}</span>
      </div>
      <div class="goals-grid">
        ${section.goals.map((goal) => html`<zen-goal-card .goal=${goal}></zen-goal-card>`)}
      </div>
    `;
  }

  render() {
    return html`
      ${this.sections.map((section) => this.renderSection(section))}
      ${this.moreLabel ? html`
        <div class="goal-list-more">
          <button class="btn btn-outline btn-sm" @click=${() => this.requestMore()}>
            <span class="mi mi-sm">expand_more</span>
            <span>${this.moreLabel}</span>
          </button>
        </div>
      ` : nothing}
    `;
  }
}

defineZenComponent('zen-goal-list', ZenGoalList);
